import React from 'react';

const CoreScooterFeature = () => {
    return (
        <div>
            <section class=" 2xl:py-24 2xl:bg-white">
                <div class="px-4 mx-auto overflow-hidden  lg:w-[1500px] sm:px-6 lg:px-8">
                    <div>
                        <div class="grid items-center grid-cols-1 gap-y-12 lg:grid-cols-2 lg:gap-x-8 2xl:gap-x-20">
                            <div data-aos="flip-left" data-aos-duration="400">
                                <h2 class="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl lg:leading-tight">Less Noise Pollution, Moving Around Swiftly</h2>
                                <p class="mt-4 text-base text-black">In our fast-paced world, reducing noise pollution and moving around swiftly have become critical factors for urban dwellers. Whether it's walking, cycling, or using public transport, people want to get to their destinations quickly and quietly. By adopting sustainable transportation solutions, we can reduce noise pollution, improve air quality, and create a more livable environment for everyone. Let's explore the benefits of eco-friendly transportation and make our cities a more peaceful place to live.</p>
                            </div>

                            <div >
                                <img data-aos="flip-right" class="h-[600px]" src="https://hugge.qodeinteractive.com/wp-content/uploads/2021/04/home-12-img-11.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default CoreScooterFeature;